import { z } from "zod";

export const privacy = z
  .object({
    displayProfilePicture: z.boolean().default(true),
    displayRealName: z.boolean().default(true),
  })
  .default({
    displayProfilePicture: true,
    displayRealName: true,
  });
